import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { FaMoon, FaSun } from 'react-icons/fa';
import DiscountStrip from './component/DiscountStrip'; 

export default function Payment() {
  const navigate = useNavigate();
  const [dark, setDark] = useState(true);

  const planId = localStorage.getItem('planId');
  const planTitle = localStorage.getItem('planTitle');
  const originalPrice = parseInt(localStorage.getItem('price')) || 0;

  const [discountCode, setDiscountCode] = useState('');
  const [discountAmount, setDiscountAmount] = useState(0);
  const [finalPrice, setFinalPrice] = useState(originalPrice);
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
const API_URL = process.env.REACT_APP_API_URL;

  // اگر اطلاعات لازم موجود نیست، ریدایرکت به صفحه قبل
  useEffect(() => {
    console.log(planId)
    console.log(originalPrice)

    if (!planId || originalPrice === null) {
      alert('اطلاعات پرداخت ناقص است. لطفاً دوباره تلاش کنید.');
      navigate('/summary');
    }
  }, [planId, originalPrice, navigate]);

  const applyDiscount = async () => {
    if (!discountCode) return;
    setLoading(true);
    setError('');

    try {
      const res = await fetch('https://api.mogym.ir/api/payment/calculate-discount', {
        method: 'POST',
                headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${localStorage.getItem('token')}`
        },
        body: JSON.stringify({ PlanId:planId, DiscountCode:discountCode })
      });

      const data = await res.json();

      if (res.status === 200 && data.Result.DiscountAmount >= 0) {
        setDiscountAmount(data.Result.DiscountAmount);
        setFinalPrice(data.Result.OriginalAmount - data.Result.DiscountAmount);
      } else {
  setError(data?.Message || 'کد تخفیف معتبر نیست.');
        setDiscountAmount(0);
        setFinalPrice(originalPrice);
      }
    } catch {
      setError('خطا در ارتباط با سرور.');
    }
    setLoading(false);
  };

  const handlePayment = async () => {
    setLoading(true);
    setError('');

    try {
      const res = await fetch('https://api.mogym.ir/api/payment/start', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${localStorage.getItem('token')}`
        },
        body: JSON.stringify({
          planId,
          discountCode: discountCode || null
        })
      });

      const data = await res.json();

      if (res.status === 200 && data.redirectUrl) {
        window.location.href = data.redirectUrl;
      } else {
        setError('خطا در شروع پرداخت.');
      }
    } catch {
      setError('مشکل در ارتباط با سرور پرداخت.');
    }

    setLoading(false);
  };

  return (
    <div className={dark ? 'dark' : ''}>
            <div className="bg-white dark:bg-[#0e1015] text-black dark:text-white font-vazir min-h-screen transition-all duration-300">
        {/* Discount Banner */}
    <DiscountStrip />


      <div className="flex-1 min-h-[calc(100vh-48px)] grid place-items-center px-4">

        <div className="bg-white dark:bg-[#1a1d2e] p-6 rounded-xl shadow max-w-md w-full text-center z-10">
          <h1 className="text-xl font-bold mb-4">پرداخت</h1>
          <h2 className="text-lg mb-2">برنامه انتخابی: {planTitle}</h2>
          <p className="text-sm text-gray-500 mb-4">
            مبلغ اولیه: {originalPrice.toLocaleString()} تومان
          </p>

          <div className="flex gap-2 mb-4">
            <input
              type="text"
              placeholder="کد تخفیف"
              value={discountCode}
              onChange={(e) => setDiscountCode(e.target.value)}
              className="flex-1 p-2 rounded-xl border dark:border-gray-600 bg-white dark:bg-[#2a2f3b]"
            />
            <button
              onClick={applyDiscount}
              disabled={!discountCode}
              className="px-4 py-2 bg-blue-600 text-white rounded-xl disabled:opacity-40"
            >
              اعمال
            </button>
          </div>

          {discountAmount > 0 && (
            <div className="bg-green-100 dark:bg-green-900 text-green-800 dark:text-green-300 rounded-xl p-3 mb-4 text-sm">
              <p>تخفیف: {discountAmount.toLocaleString()} تومان</p>
              <p className="font-bold">قیمت نهایی: {finalPrice.toLocaleString()} تومان</p>
            </div>
          )}

          {error && <p className="text-red-500 text-sm mb-3">{error}</p>}

          <button
            onClick={handlePayment}
            className="bg-green-600 hover:bg-green-700 text-white w-full py-3 rounded-xl disabled:opacity-50"
            disabled={!planId || loading}
          >
            {loading ? 'در حال انتقال...' : 'پرداخت نهایی'}
          </button>
        </div>
</div>
        {/* Toggle theme button */}
        {/* <button
          onClick={() => setDark(!dark)}
          className="fixed top-4 right-4 z-50 px-3 py-2 bg-gray-700 text-white rounded-full shadow-lg"
        >
          {dark ? <FaSun className="text-yellow-400" /> : <FaMoon className="text-blue-500" />}
        </button> */}
      </div>
    </div>
  );
}
